import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Simcard(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.21 1a3.14 3.14 0 012.165.854l4.473 4.237c.593.56.934 1.342.934 2.145V20c0 1.654-1.453 3-3.238 3H6.238C4.453 23 3 21.654 3 20V4c0-1.654 1.453-3 3.238-3h7.972zm0 2H6.238C5.555 3 5 3.448 5 4v16c0 .552.555 1 1.238 1h12.306c.682 0 1.238-.448 1.238-1V8.236a.948.948 0 00-.307-.692h-.001L15 3.308A1.153 1.153 0 0014.21 3zM8.447 19.945c-1.103 0-2-.897-2-2v-5.951c0-1.103.897-2 2-2h7.888c1.102 0 2 .897 2 2v5.95c0 1.104-.898 2-2 2H8.447zm0-2h4.551V16.57H8.447l.001 1.375zm1.303-5.952H8.447l-.001 2.576h5.553a1 1 0 011 1l-.001 2.375h1.338l-.001-5.95H15.03l.001.543a1 1 0 11-2 0l-.001-.544h-1.28v.544a1 1 0 11-2 0v-.544z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoSimcard = React.memo(Simcard);
export default MemoSimcard;